import { render, staticRenderFns } from "./InstallBtn.vue?vue&type=template&id=40711fac&"
import script from "./InstallBtn.vue?vue&type=script&lang=ts&"
export * from "./InstallBtn.vue?vue&type=script&lang=ts&"
import style0 from "./InstallBtn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports